import { render, staticRenderFns } from "./trouble-chat-backup-not-working.vue?vue&type=template&id=f80645fc"
import script from "./trouble-chat-backup-not-working.vue?vue&type=script&lang=js"
export * from "./trouble-chat-backup-not-working.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports